export const OTHER = 'Others';
export enum ARCHES {
  BOTH = 'Both',
  UPPER = 'Upper',
  LOWER = 'Lower'
}
export const CANINE = 'canine';
export const MOLAR = 'molar';
